/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayCompetitionParticipant
 */
export interface PayCompetitionParticipant {
    /**
     * 
     * @type {string}
     * @memberof PayCompetitionParticipant
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PayCompetitionParticipant
     */
    entryFeePaid?: boolean;
}

/**
 * Check if a given object implements the PayCompetitionParticipant interface.
 */
export function instanceOfPayCompetitionParticipant(value: object): value is PayCompetitionParticipant {
    return true;
}

export function PayCompetitionParticipantFromJSON(json: any): PayCompetitionParticipant {
    return PayCompetitionParticipantFromJSONTyped(json, false);
}

export function PayCompetitionParticipantFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayCompetitionParticipant {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'entryFeePaid': json['entryFeePaid'] == null ? undefined : json['entryFeePaid'],
    };
}

export function PayCompetitionParticipantToJSON(json: any): PayCompetitionParticipant {
    return PayCompetitionParticipantToJSONTyped(json, false);
}

export function PayCompetitionParticipantToJSONTyped(value?: PayCompetitionParticipant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entryFeePaid': value['entryFeePaid'],
    };
}

